import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

const DASHBOARD = 'site/dashboard';

export default {
    methods: {
        async getDashboard() {
            const url = `${baseURL}${DASHBOARD}`
            const response = await this.httpSession().get(url)
            console.debug('[DASHBOARD][getDashboard] RESPONSE', response.data)
            return response.data;
        }
    },
    mixins: [SessionApi],
};
